import * as types from "../actions/types";

const initialState = {
    list: [],
    listLoaded: 0,
    listLoading: false,
    datas: [],
    loaded: 0,

    fetchLoading: false,
    createLoading: false,
    editLoading: false,
    deleteLoading: false,

    createError: false,
    editError: false
};

function pointsOfAttention(state = initialState, action) {
    switch (action.type) {
        // FETCH
        case types.POINTS_OF_ATTENTION_FETCH_REQUESTED: {
            return {
                ...state,
                datas: [],
                loaded: 0,
                fetchLoading: true,
            };
        }
        case types.POINTS_OF_ATTENTION_FETCH_SUCCESS: {
            return {
                ...state,
                datas: action.data,
                loaded: Date.now(),
                fetchLoading: false,
            };
        }
        case types.POINTS_OF_ATTENTION_FETCH_FAILURE: {
            return {
                ...state,
                fetchLoading: false
            };
        }

        // CREATE
        case types.POINTS_OF_ATTENTION_CREATE_REQUESTED: {
            return {
                ...state,
                createLoading: true,
                createError: false
            };
        }
        case types.POINTS_OF_ATTENTION_CREATE_SUCCESS: {
            return {
                ...state,
                datas: [ ...state.datas, action.data ],
                createLoading: false,
                createError: false
            };
        }
        case types.POINTS_OF_ATTENTION_CREATE_FAILURE: {
            return {
                ...state,
                createLoading: false,
                createError: action.data
            };
        }

        // EDIT
        case types.POINTS_OF_ATTENTION_EDIT_REQUESTED: {
            return {
                ...state,
                editLoading: true,
                editError: false,
            };
        }
        case types.POINTS_OF_ATTENTION_EDIT_SUCCESS: {
            return {
                ...state,
                datas: state.datas.map((data) => data.id === action.data.id ? action.data : data),
                editLoading: false,
                editError: false
            };
        }
        case types.POINTS_OF_ATTENTION_EDIT_FAILURE: {
            return {
                ...state,
                editLoading: false,
                editError: action.data

            };
        }

        // DELETE
        case types.POINTS_OF_ATTENTION_DELETE_REQUESTED: {
            return {
                ...state,
                deleteLoading: true
            };
        }
        case types.POINTS_OF_ATTENTION_DELETE_SUCCESS: {
            return {
                ...state,
                datas: state.datas.filter(({ id }) => id !== action.data),
                deleteLoading: false
            };
        }
        case types.POINTS_OF_ATTENTION_DELETE_FAILURE: {
            return {
                ...state,
                deleteLoading: false
            };
        }
        
        // DEFAULT
        default:
            return state;
    }
}

export default pointsOfAttention;
